/**
 * Strip potentially dangerous characters from text input.
 * Matches the same approach used in SearchInput.
 * Do NOT apply to TinyMCE/rich-text fields (they intentionally contain HTML).
 */
export function sanitizeInput(value: string): string {
  return value.replace(/[<>{}]/g, "");
}
